import UserStore from '../stores/UserStore';
import PosStore from '../stores/PosStore';
import AppDispatcher from '../utils/AppDispatcher';

import NotificationActions from '../actions/NotificationActions';
import { endPoints as EndPoints, actions as ActionTypes } from '../constants/PosConstants';
import AjaxPromises from '../utils/AjaxPromises';
import PosCartStore from '../stores/PosCartStore';

var PrintActions = {
    printPreOrderReceipt(guest) {
        var formData = UserStore.getApiData();
        formData.PrinterId = PosStore.getState().receiptPrinter.PrinterId;
        formData.AcctId = guest.Guest_id;
        formData.ShipmentId = guest.ShipmentId;

        $.ajax({
            type: 'POST',
            url: EndPoints.PRINT_PREORDER_RECEIPT,
            xhrFields: {
                withCredentials: true
            },
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: 'application/json',
        });
    },

    printPickListReceipt(guest) {
        var formData = UserStore.getApiData();
        formData.PrinterId = PosStore.getState().receiptPrinter.PrinterId;
        formData.Guest_id = guest.Guest_id;
        formData.ShipmentId = guest.ShipmentId;

        $.ajax({
            type: 'POST',
            url: EndPoints.PRINT_PICKLIST_RECEIPT,
            xhrFields: {
                withCredentials: true
            },
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: 'application/json',
        });
    },

    emailReceipt(receiptId, email) {
        var formData = UserStore.getApiData({
            Email: email,
            ShipmentId: receiptId,

        });
        AjaxPromises.POST(EndPoints.EMAIL_RECEIPT, formData).then(res => {
            if(!res.Result) {
                NotificationActions.error('Error sending email');
                return;
            }

            NotificationActions.success('Email sent');
        });
        
    },

    previewReceipt(receiptId, manual, target) {
        var formData = UserStore.getApiData();

        NotificationActions.alert('Previewing Receipt...');

        AjaxPromises.POST(EndPoints.PRINT_PREVIEW_RECEIPT, {
            ReceiptType: 'Receipt',
            ReceiptParameters: receiptId,
            LocId: formData.LocId,
            LspId: formData.LspId,
            SessionId: formData.sessionId,
            PrinterId: PosStore.getState().receiptPrinter.PrinterId,
        }).then(res => {
            if(!res.Result) {
                NotificationActions.error('Error generating preview');
            }

            var binaryString = window.atob(res.Data);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }), '_blank');
            link.download = 'receipt.pdf';
            link.click();   
        });
        
    },
    previewLabels(guest, cart) {
        var items = (cart || []).filter(i => {
            if (UserStore.getState().selectedLocation.PrintNonCannabisLabels)
                return i;

            return (
                (i.CannabisProduct === 'Yes') ||
                (i.CannabisInventory === 'Yes') ||
                (i.CannbisProduct === 'Yes')
            );
        });

        var PackagesToPrint = items.map(i => ({
            ShipmentId: guest.ShipmentId,
            AllocatedInventoryId: i.InventoryId,
            Count: i.QtySelected,
            PackageItemId: i.PackageItemId,
            BatchId: i.BatchId
        }));

        var formData = UserStore.getApiData({
            ShipmentId: guest.ShipmentId,
            LabelId: PosStore.getState().defaultLabel,
            PackagesToPrint,
            LabelType: "ProductProd",
            PrinterId: PosStore.getState().labelPrinter.PrinterId,
        });

        $.ajax({
            type: 'POST',
            url: EndPoints.PRINT_PREVIEW_LABELS,
            xhrFields: {
                withCredentials: true
            },
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: 'application/json'
        }).then(res => {
            if(!res.Result) {
                NotificationActions.error('Error generating preview');
            }

            var binaryString = window.atob(res.Data);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }), '_blank');
            link.download = 'labels.pdf';
            link.click();   
        });        
    },

    printPreCheckoutReceipt(payload) {
        const { selectedLocation } = UserStore.getState();
        const { StatefulCheckoutTotalCalculated } = PosCartStore.getCartSummary();

        if (selectedLocation.StatefulCheckout && !StatefulCheckoutTotalCalculated) {
            return NotificationActions.error('Please calculate totals prior to printing receipt');
        }

        let formData = UserStore.getApiData();

        NotificationActions.alert('Printing Receipt...');
        $.ajax({
            type: 'POST',
            url: EndPoints.PRINT_RECEIPT,
            xhrFields: {
                withCredentials: true
            },
            data: JSON.stringify({
                ReceiptType: 'Receipt',
                ReceiptParameters: payload.receiptId,
                LocId: formData.LocId,
                LspId: formData.LspId,
                SessionId: formData.sessionId,
                PrinterId: PosStore.getState().receiptPrinter.PrinterId,
                SubTotal: payload.subTotal,
                Total: payload.total,
            }),
            dataType: 'json',
            contentType: 'application/json',
            timeout: 60000,
            error: function(){
                NotificationActions.error('Error Printing Receipt: Connection timed out');
            }
        }).then((res) =>{
            if(res.Result) {
                NotificationActions.success('Receipt Printed');
            }
            else {
                PrintActions.notification('Error Printing Receipt: ' + res.Message, 'error');
            }
        });
        
    },

    printReceipt(receiptId, manual, target) {
        var formData = UserStore.getApiData();

        NotificationActions.alert('Printing Receipt...');
        $.ajax({
            type: 'POST',
            xhrFields: {
                withCredentials: true
            },
            url: EndPoints.PRINT_RECEIPT,
            data: JSON.stringify({
                ReceiptType: 'Receipt',
                ReceiptParameters: receiptId,
                LocId: formData.LocId,
                LspId: formData.LspId,
                SessionId: formData.sessionId,
                PrinterId: PosStore.getState().receiptPrinter.PrinterId,
                PopCashDrawer: true
            }),
            dataType: 'json',
            contentType: 'application/json',
            timeout: 60000,
            error: function(){
                NotificationActions.error('Error Printing Receipt: Connection timed out');
            }
        }).then((res) =>{
            if(res.Result) {
                NotificationActions.success('Receipt Printed');
            }
            else {
                PrintActions.notification('Error Printing Receipt: ' + res.Message, 'error');
            }
        });
        
    },

    printAllLabels(guest, cart) {
        var items = (cart || []).filter(i => {
            if (UserStore.getState().selectedLocation.PrintNonCannabisLabels)
                return i;

            return (
                (i.CannabisProduct === 'Yes') ||
                (i.CannabisInventory === 'Yes') ||
                (i.CannbisProduct === 'Yes')
            );
        });

        var PackagesToPrint = items.map(i => ({
            ShipmentId: guest.ShipmentId,
            AllocatedInventoryId: i.InventoryId || i.PosId,
            Count: i.QtySelected,
            PackageItemId: i.PackageItemId,
            SerialNumber: i.SerialNo
        }));

        var formData = UserStore.getApiData({
            ShipmentId: guest.ShipmentId,
            LabelId: PosStore.getState().defaultLabel,
            PackagesToPrint,
            LabelType: 'ProductProd',
            PrinterId: PosStore.getState().labelPrinter.PrinterId
        });
        
        NotificationActions.alert('Printing Labels...');
        $.ajax({
            type: 'POST',
            xhrFields: {
                withCredentials: true
            },
            url: EndPoints.PRINT_LABEL,
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: 'application/json',
            timeout: 60000,
            error: function() {
                NotificationActions.error('Error Printing Labels: Connection timed out')
            }
        }).then((res) => {
            if(res.Result) {
                AppDispatcher.dispatch({
                    actionType  : ActionTypes.ALL_LABELS_PRINTED,
                    data        : guest
                });
                NotificationActions.success('Labels Printed');
            }
            else {
                PrintActions.notification('Error Printing All Labels: ' + res.Message, 'error');
            }
        })
    },
    printLabel(item, guest, printAll, labelId, autoPrint = false) {
        if(!UserStore.getState().selectedLocation.PrintNonCannabisLabels) {
            if (item.hasOwnProperty('CannabisInventory')){
                item.CannabisProduct = item.CannabisInventory;
            }

            if (item.hasOwnProperty('CannbisProduct')) {
                item.CannabisProduct = item.CannbisProduct;
            }

            if (item.CannabisProduct !== 'Yes') {
                if(!autoPrint) {
                    NotificationActions.addNotification({
                        type : 'alert',
                        body : 'Product is not setup as a Cannabis product',
                    });
                }
                return false;
            }
        }
        var location = UserStore.getState().selectedLocation;
        var formData        = UserStore.getApiData();
        formData.ProductId  = (item.ProductId || item.ProdId);

        if(!!item.DefaultLabelId) {
            labelId = item.DefaultLabelId
        }

        formData = UserStore.getApiData();
        if (!labelId) {
            if (PosStore.getState().defaultLabel === '-' || PosStore.getState().defaultLabel === 0) {
                Promise.resolve().then(() => {
                    NotificationActions.addNotification({
                        type : 'alert',
                        body : 'Select Default Label',
                    });
                });
                return false;
            }
            formData.LabelId = PosStore.getState().defaultLabel;
        }
        if (labelId) {
            formData.LabelId = labelId;
        }

        var packageId = printAll ? (item.ProductId || item.ProdId) : 'z'+(item.ProductId || item.ProdId);

        
        var doPrint = (printerId) => {
            NotificationActions.alert('Printing Labels...');
            $.ajax({
                type: 'POST',
                xhrFields: {
                    withCredentials: true
                },
                url: EndPoints.PRINT_LABEL,
                data: JSON.stringify({
                    SerialNumber: item.SerialNo,
                    ShipmentId: guest.ShipmentId,
                    Count: printAll ? item.QtySelected : 1,
                    LabelId: formData.LabelId,
                    BatchId: guest.ShipmentId,
                    PackagesToPrint: [{
                        ShipmentId: guest.ShipmentId,
                        AllocatedInventoryId: item.InventoryId || item.PosId,
                        Count: printAll ? item.QtySelected : 1,
                        SerialNumber : item.SerialNo,
                        PackageItemId : item.PackageItemId,
                        PackageQuantity: item.WgtCnt == "Wgt" ? item.Grams / item.QtyAllocated : 1
                    }],
                    LabelType: 'ProductProd',
                    LocId: formData.LocId,
                    LspId: formData.LspId,
                    SessionId: formData.sessionId,
                    PrinterId: printerId,
                    UserId: formData.UserId,
                }),
                dataType: 'json',
                contentType: 'application/json',
            }).then( (res) => {
                if(res.Result){
                    NotificationActions.success('Labels Printed');
                }
                else{
                    PrintActions.notification('Error Printing All Labels: ' + res.Message, 'error');
                }
            });
        };

        if(location.AllowDefaultProductLabels) {
            var register = UserStore.getState().selectedRegister;
            if(!register) {
                console.error('No register selected');
                return;
            }

            $.ajax({
                type: 'POST',
                url: EndPoints.GET_LABEL_PRINTER_FOR_TERMINAL,
                xhrFields: {
                    withCredentials: true
                },
                data: JSON.stringify(UserStore.getApiData({
                    LabelId: formData.LabelId,
                    TerminalId: register.id
                })),
                dataType: 'json',
                contentType: 'application/json'
            }).then(resp => {
                if(!resp.Result) {
                    console.error('Error getting printer:', resp);
                }
                else {
                    doPrint(resp.Data || PosStore.getState().labelPrinter.PrinterId);
                }
            });
        }
        else {
            doPrint(PosStore.getState().labelPrinter.PrinterId);
        }
       

        return false;
    },

    notification(message, type, sticky, fullscreen) {
        setTimeout(() => {
            NotificationActions.addNotification({
                type : type,
                body : message,
                fullscreen : fullscreen,
                sticky : sticky
            });
        }, 100);
    }
}

export default PrintActions;



// WEBPACK FOOTER //
// ./ui_src/app/actions/PrintActions.jsx